import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ActiveCampaigns = ({ campaigns, onViewDetails }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 2
    })?.format(amount);
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })?.format(new Date(date));
  };

  const getProgressColor = (progress) => {
    if (progress >= 75) return 'bg-success';
    if (progress >= 50) return 'bg-primary';
    if (progress >= 25) return 'bg-warning';
    return 'bg-error';
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'in-progress':
        return 'bg-primary/10 text-primary';
      case 'review':
        return 'bg-warning/10 text-warning';
      case 'completed':
        return 'bg-success/10 text-success';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'in-progress':
        return 'Devam Ediyor';
      case 'review':
        return 'İncelemede';
      case 'completed':
        return 'Tamamlandı';
      default:
        return 'Bilinmiyor';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-foreground">Aktif Kampanyalar</h2>
        <span className="text-sm text-muted-foreground">{campaigns?.length} kampanya</span>
      </div>
      <div className="space-y-4">
        {campaigns?.map((campaign) => (
          <div key={campaign?.id} className="bg-muted/50 rounded-lg p-4 hover:shadow-elevation-1 transition-smooth">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0">
                <Image 
                  src={campaign?.artistImage} 
                  alt={campaign?.artistImageAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-1">
                  <h3 className="text-base font-semibold text-foreground">{campaign?.title}</h3>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getStatusColor(campaign?.status)}`}>
                    {getStatusText(campaign?.status)}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground mb-2">{campaign?.artistName}</p>
                <div className="flex items-center gap-3 text-xs text-muted-foreground">
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={12} />
                    {formatDate(campaign?.deadline)}
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="DollarSign" size={12} />
                    {formatCurrency(campaign?.payment)}
                  </span>
                </div>
              </div>
            </div>

            <div className="mb-4">
              <div className="flex items-center justify-between text-xs mb-2">
                <span className="text-muted-foreground">İlerleme</span>
                <span className="font-medium text-foreground">{campaign?.progress}%</span>
              </div>
              <div className="w-full h-2 bg-background rounded-full overflow-hidden">
                <div 
                  className={`h-full ${getProgressColor(campaign?.progress)} transition-all duration-300`}
                  style={{ width: `${campaign?.progress}%` }}
                />
              </div>
            </div>

            <div className="flex items-center gap-2 mb-4">
              {campaign?.milestones?.map((milestone, index) => (
                <div key={index} className="flex-1">
                  <div className={`
                    text-xs font-medium px-2 py-1 rounded text-center
                    ${milestone?.completed ? 'bg-success/10 text-success' : 'bg-background text-muted-foreground'}
                  `}>
                    {milestone?.name}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-2">
              <Button 
                variant="default" 
                onClick={() => onViewDetails(campaign?.id)}
                className="flex-1"
              >
                Detayları Gör
              </Button>
              <Button 
                variant="outline" 
                iconName="Upload"
                className="flex-1"
              >
                İçerik Yükle
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActiveCampaigns;